import { ListItemIcon, ListItemText } from '@mui/material';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import LabelIcon from '@mui/icons-material/Label';
import { Download as DownloadIcon } from '@mui/icons-material';
import { StyledList, StyledListItem } from '@/components/AssetsPage/PopoverList';
import { pluralize } from '@/utils/format';

export const BulkActionsMenuContent = ({
  itemCount,
  assetCount,
  canMove,
  canDelete,
  canReprocess,
  canLabel,
  onMoveClick,
  onDeleteClick,
  onDownloadClick,
  onReprocessClick,
  onLabelClick,
}: {
  itemCount: number;
  assetCount?: number;
  canMove?: boolean;
  canDelete?: boolean;
  canReprocess?: boolean;
  canLabel?: boolean;
  onMoveClick: () => void;
  onDeleteClick: () => void;
  onDownloadClick?: () => void;
  onReprocessClick?: () => void;
  onLabelClick?: () => void;
}) => (
  <StyledList sx={{ padding: 0 }}>
    {onDownloadClick && (
      <StyledListItem onClick={onDownloadClick}>
        <ListItemIcon>
          <DownloadIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Download {pluralize(itemCount, 'item', 'items')}</ListItemText>
      </StyledListItem>
    )}
    {canMove && (
      <StyledListItem onClick={onMoveClick}>
        <ListItemIcon>
          <DriveFileMoveIcon sx={{ fontSize: '18px', color: 'success.main' }} />
        </ListItemIcon>
        <ListItemText>Move {pluralize(itemCount, 'item', 'items')}</ListItemText>
      </StyledListItem>
    )}
    {canReprocess && onReprocessClick && (
      <StyledListItem onClick={onReprocessClick}>
        <ListItemIcon>
          <AutorenewIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Reprocess {pluralize(assetCount ?? itemCount, 'asset', 'assets')}</ListItemText>
      </StyledListItem>
    )}
    {canLabel && onLabelClick && (
      <StyledListItem onClick={onLabelClick}>
        <ListItemIcon>
          <LabelIcon sx={{ fontSize: '18px' }} />
        </ListItemIcon>
        <ListItemText>Label {pluralize(assetCount ?? itemCount, 'asset', 'assets')}</ListItemText>
      </StyledListItem>
    )}
    {canDelete && (
      <StyledListItem onClick={onDeleteClick}>
        <ListItemIcon>
          <DeleteIcon sx={{ fontSize: '18px' }} color='error' />
        </ListItemIcon>
        <ListItemText>Delete {pluralize(itemCount, 'item', 'items')}</ListItemText>
      </StyledListItem>
    )}
  </StyledList>
);
